import { render, staticRenderFns } from "./FuelSupplyImport.vue?vue&type=template&id=20b3952a&scoped=true"
import script from "./FuelSupplyImport.vue?vue&type=script&lang=js"
export * from "./FuelSupplyImport.vue?vue&type=script&lang=js"
import style0 from "./FuelSupplyImport.vue?vue&type=style&index=0&id=20b3952a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3952a",
  null
  
)

export default component.exports